// UI Elements
import Button from "../../../../ui-elements/Button/Button";
import DisplayBox from "../../../../ui-elements/DisplayBox/DisplayBox";
import Label from "../../../../ui-elements/Label/Label";

// Icons
import { faEdit } from "@fortawesome/pro-solid-svg-icons";

// Services & Utils
import { getTableDate } from "../../../../services/utils";

// Types
import { RiskScoreDto, RiskScoreFormValues } from "../../../../types/DueDiligenceTypes";

// Local
import { riskToLabelTypeMap } from "../../CompaniesTable";

interface IProps {
    riskScore: RiskScoreDto;
    setRiskScoreModal_isOpen: (isOpen: boolean) => void;
    setRiskScoreModal_data: (data: RiskScoreFormValues) => void;
    customerName?: string;
}
const QuestionaireResults: React.FC<IProps> = ({
    riskScore,
    setRiskScoreModal_isOpen,
    setRiskScoreModal_data,
    customerName
}) => {
    return <DisplayBox id="questionaire-results">
        <div className="questionaire-results">
            <div className="questionaire-results__head">
                <div className="questionaire-results__head--left">
                    <h6 className="questionaire-results__title">Niðurstaða áhættumats: </h6>
                    {riskScore.riskscore &&
                        <Label size='lg' text={riskScore.riskscore} labelType={riskToLabelTypeMap[riskScore.riskscore.split(' ')[0]]}>meðal áhætta</Label>
                    }
                    <Button size="sm"
                        buttonType="secondary"
                        icon={faEdit}
                        onClick={() => {
                            setRiskScoreModal_data({
                                riskscoreId: riskScore.id ?? null,
                                riskScore: riskScore.riskscore,
                                description: riskScore.description ?? '',
                                name: customerName ?? ''
                            });
                            setRiskScoreModal_isOpen(true);
                        }}>
                        Breyta
                    </Button>
                </div>
                {/*<div className="questionaire-results__checkbox">
                    <Checkbox id="athugunarlisti" label="Athugunarlisti" />
                    <Tooltip tooltipClassName="tooltip-athugunarlisti" noUnderline tooltip={<div className="tooltip-text">
                        <p><strong>Áhættusöm / ósamvinnuþýð ríki</strong></p>
                        Tilkynningarskyldum aðilum sem eiga í viðskiptum við aðila sem tengjast áhættusömum og ósamvinnuþýðum ríkjum,
                        er skilt að framkvæma aukna áreiðanleikakönnun á þeim í samræmi við 13. og 14. gr. laga nr. 140/2018. <br />
                        Kerfið keyrir á móti gagnagrunni Keldunnar sem heldur utanum áhættusöm og ósamvinnuþýð ríki í samræmi við 6. gr. laga nr. 140/2018.
                    </div>} text={<FontAwesomeIcon icon={faInfoCircle} />} />
                </div>*/}
            </div>
            <div className="questionaire-results__summary">
                <div className="questionaire-results__summary--top">
                    <p className="paragraph-small--bold ">{riskScore.description ? 'Athugasemd: ' : 'Engin athugasemd'}</p>
                    <span className="comment-text">{riskScore.description ?? ''}</span>
                </div>
                <div className="questionaire-results__summary--bottom">
                    <div className="questionaire-results__summary--bottom-left">
                        <span className="paragraph-xsmall paragraph--italic">Áhættumat síðast uppfært:</span>
                        <span className="paragraph-xsmall">{getTableDate(riskScore.riskscoreFinishedTimestamp, 'DD/MM/YYYY HH:MM:SS', '.')}</span>
                    </div>
                    <div className="questionaire-results__summary--bottom-right">
                        <span className="paragraph-xsmall paragraph--italic updated">Uppfært af:</span>
                        <span className="paragraph-xsmall name">{riskScore.riskscoreUpdatedByName?.trim() ? riskScore.riskscoreUpdatedByName : riskScore.riskscoreUpdatedByUsername}</span>
                    </div>
                </div>
            </div>
        </div>
    </DisplayBox>
}

export default QuestionaireResults;